import createReducer from 'utils/createReducer';

const INIT_STATE = {
  singleData: null,
  pushing: false,
  fetchingSingle: false,
  fetchingActiveOrders: false,
  activeOrders: [],
};

// Actions
const FETCH_SINGLE_REQUEST = 'recurringOrders/FETCH_SINGLE_REQUEST';
const FETCH_SINGLE_CANCEL = 'recurringOrders/FETCH_SINGLE_CANCEL';
const FETCH_SINGLE_DONE = 'recurringOrders/FETCH_SINGLE_DONE';
const REMOVE_SINGLE = 'recurringOrders/REMOVE_SINGLE';
const FETCH_ACTIVE_ORDERS_DONE = 'recurringOrders/FETCH_ACTIVE_ORDERS_DONE';
const FETCH_ACTIVE_ORDERS_REQUEST = 'recurringOrders/FETCH_ACTIVE_ORDERS_REQUEST';
const FETCH_ACTIVE_ORDERS_CANCEL = 'recurringOrders/FETCH_ACTIVE_ORDERS_CANCEL';
const UPDATE_RECURRING_ORDER_INFO_REQUEST = 'recurringOrders/UPDATE_RECURRING_ORDER_INFO_REQUEST';
const UPDATE_RECURRING_ORDER_INFO_DONE = 'recurringOrders/UPDATE_RECURRING_ORDER_INFO_DONE';
const UPDATE_RECURRING_ORDER_INFO_CANCEL = 'recurringOrders/UPDATE_RECURRING_ORDER_INFO_CANCEL';

// Reducers
export default createReducer(INIT_STATE, {
  [FETCH_SINGLE_REQUEST](state) {
    return {
      ...state,
      fetchingSingle: true,
    };
  },
  [FETCH_SINGLE_CANCEL](state, payload) {
    return {
      ...state,
      singledata: null,
      fetchingSingle: false,
      error: payload,
    };
  },
  [FETCH_SINGLE_DONE](state, payload) {
    return {
      ...state,
      singleData: payload,
      fetchingSingle: false,
      error: null,
    };
  },
  [UPDATE_RECURRING_ORDER_INFO_REQUEST](state) {
    return {
      ...state,
      fetchingSingle: true,
      fetchingActiveOrders: true,
    };
  },
  [UPDATE_RECURRING_ORDER_INFO_DONE](state, payload) {
    return {
      ...state,
      activeOrders: payload.activeOrders,
      singleData: payload.recurringOrder,
      fetchingSingle: false,
      fetchingActiveOrders: false,
      error: null,
    };
  },
  [UPDATE_RECURRING_ORDER_INFO_CANCEL](state, payload) {
    return {
      ...state,
      activeOrders: [],
      singleData: null,
      fetchingSingle: false,
      fetchingActiveOrders: false,
      error: payload,
    };
  },
  [REMOVE_SINGLE](state) {
    return {
      ...state,
      singleData: null,
      fetchingSingle: false,
      error: null,
    };
  },
  [FETCH_ACTIVE_ORDERS_DONE](state, payload) {
    return {
      ...state,
      activeOrders: payload,
      fetchingActiveOrders: false,
    };
  },
  [FETCH_ACTIVE_ORDERS_REQUEST](state) {
    return {
      ...state,
      fetchingActiveOrders: true,
    };
  },
  [FETCH_ACTIVE_ORDERS_CANCEL](state, payload) {
    return {
      ...state,
      fetchingActiveOrders: false,
      activeOrders: [],
      error: payload,
    };
  },
});

// Action creators
export const requestSingle = () => ({
  type: FETCH_SINGLE_REQUEST,
});

export const cancelSingle = (payload) => ({
  type: FETCH_SINGLE_CANCEL,
  payload,
});

export const doneSingle = (payload) => ({
  type: FETCH_SINGLE_DONE,
  payload,
});

export const removeSingle = () => ({
  type: REMOVE_SINGLE,
});

export const requestActiveOrders = () => ({
  type: FETCH_ACTIVE_ORDERS_REQUEST,
});

export const doneActiveOrders = (payload) => ({
  type: FETCH_ACTIVE_ORDERS_DONE,
  payload,
});

export const cancelRequestActiveOrders = (payload) => ({
  type: FETCH_ACTIVE_ORDERS_CANCEL,
  payload,
});

export const doneUpdateRecurringOrderInfo = (payload) => ({
  type: UPDATE_RECURRING_ORDER_INFO_DONE,
  payload,
});

export const requestUpdateRecurringOrderInfo = (payload) => ({
  type: UPDATE_RECURRING_ORDER_INFO_REQUEST,
  payload,
});

export const cancelUpdateRecurringOrderInfo = (payload) => ({
  type: UPDATE_RECURRING_ORDER_INFO_CANCEL,
  payload,
});
